import React from 'react';
import PropTypes from 'prop-types';
import { pageTitleShape, injectPageTitle } from '../../providers/PageTitleProvider';
import './styles.css';

const PageCaption = ({ className, pageTitle }) => (
  <div styleName="pageCaptionNav18Updates" className={className}>
    <div className="hidden-mobile" styleName="pageTitleNav18Updates">
      {pageTitle.title}
    </div>
    <div className="hidden-computer hidden-tablet" styleName="pageTitleNav18Updates">
      {pageTitle.shortTitle || pageTitle.title}
    </div>
  </div>
);
PageCaption.propTypes = {
  className: PropTypes.string,
  pageTitle: pageTitleShape,
};

export default injectPageTitle(PageCaption);
